<template>
  <OmtLayoutContainer>
    <OmtRow mb="8px">
      <OmtTypography as="h1-regular"><b>Envio das imagens</b> (opcional)</OmtTypography>
    </OmtRow>
    <OmtRow mb="24px">
      <OmtTypography as="h3-bold">Adicione imagens que ajudem na análise da sua solicitação:</OmtTypography>
    </OmtRow>

    <OmtRow>
      <ImageUploader @change="onImageUploaderChange" :length="limitFiles" :initialValue="pictures" />
    </OmtRow>

    <OmtRow :desktopStart="1" :desktopEnd="6" :gridRowStart="['initial', '2']">
      <CBox>
        <CFlex mb="8px">
          <OmtIcons name="check" size="lg" mr="16px" color="var(--colors-light-support-success)" />
          <OmtTypography as="p1"><b>Arquivos suportados:</b> .jpg, .png, .heic e .pdf. com até 25mb.</OmtTypography>
        </CFlex>
        <CFlex mb="8px">
          <OmtIcons name="check" size="lg" mr="16px" color="var(--colors-light-support-success)" />
          <OmtTypography as="p1">Envie apenas <b>um documento por foto</b>.</OmtTypography>
        </CFlex>
        <CFlex mb="8px">
          <OmtIcons name="check" size="lg" mr="16px" color="var(--colors-light-support-success)" />
          <OmtTypography as="p1">Certifique-se de que todas as informações das imagens estão legíveis.</OmtTypography>
        </CFlex>
      </CBox>
    </OmtRow>

    <OmtRow mt="48px" justifyContent="center">
      <OmtButton :w="['100%', '308px !important']" @click="send">Enviar</OmtButton>
    </OmtRow>

    <SentRequestModal
      :isOpen="modalSuccess"
      :isOuvidoria="false"
      :daysAnalizy="daysAnalizy"
      :protocol="protocolo"
      @close="closeModal"
      @save="concluirAvaliacao"
    />
  </OmtLayoutContainer>
</template>

<script>
import { mapState } from "vuex";
import ImageUploader from "@/components/Molecules/ImageUploader";
import SentRequestModal from "@/components/Organisms/Requests/SentRequestModal.vue";
import { UploadArquivo, AvaliacaoAtendimento, RetornoPendencia, ValidacaoAtendimento } from "@/api/programasSaude";

export default {
  name: "UploadFileRequest",
  components: { ImageUploader, SentRequestModal },
  data() {
    return {
      pictures: [],
      daysAnalizy: 0,
      modalSuccess: false,
      protocolo: "",
      sending: false
    };
  },
  computed: {
    ...mapState("saude", ["vinculo"]),
    ...mapState("programasSaude", ["newSolicitation"]),
    ...mapState("request", ["limitFiles"])
  },
  methods: {
    onImageUploaderChange(pictures) {
      this.pictures = Array.isArray(pictures) ? pictures.filter(p => p && (p.file || p.source)) : [];
    },
    closeModal() {
      this.modalSuccess = false;
    },

    async send() {
      if (this.sending) return;
      this.sending = true;

      try {
        this.$root.$emit("show-loading");

        if (this.pictures.length > 0) {
          const formData = new FormData();
          this.pictures.forEach((p, idx) => {
            if (p.file instanceof File) {
              formData.append(`anexo${idx + 1}`, p.file, p.file.name);
            }
          });
          await UploadArquivo({ vinculo: this.vinculo, formData });
        }

        const respCriacao = await AvaliacaoAtendimento({
          vinculo: this.vinculo,
          data: {
            Atendimento: this.newSolicitation?.atendimento || "",
            Etapa: this.newSolicitation?.etapa || "S",
            Tipo: this.newSolicitation?.tipo || 601,
            ConfirmaAtendimento: this.newSolicitation?.confirmaAtendimento ?? true,
            Obs: this.newSolicitation?.observacao || "",
            Latitude: this.newSolicitation?.latitude || "",
            Longitude: this.newSolicitation?.longitude || "",
            Prestador: this.newSolicitation?.prestador || ""
          }
        });
        this.protocolo = respCriacao?.ProtocoloANS ?? "";

        await RetornoPendencia({
          vinculo: this.vinculo,
          protocolo: this.protocolo,
          observacao: this.newSolicitation?.observacao || "",
          arquivos: this.pictures.map(p => p.file)
        });

        this.modalSuccess = true;

        this.$toast({
          description: "Avaliação registrada com sucesso.",
          status: "success",
          duration: 5000,
          position: "top"
        });
      } catch (err) {
        this.$toast({
          description: "Erro ao registrar avaliação.",
          status: "error",
          duration: 5000,
          position: "top"
        });
      } finally {
        this.$root.$emit("hide-loading");
        this.sending = false;
      }
    },

    async concluirAvaliacao({ rating, obs }) {
      try {
        this.$root.$emit("show-loading");

        await ValidacaoAtendimento({
          vinculo: this.vinculo,
          protocolo: this.protocolo,
          data: {
            Nota: Number(rating),
            Obs: obs || ""
          }
        });

        this.$toast({
          description: "Solicitação enviada com sucesso.",
          status: "success",
          duration: 5000,
          position: "top"
        });

        this.$router.push("/programas-saude");
      } catch (err) {
        this.$toast({
          description: "Erro ao enviar solicitação.",
          status: "error",
          duration: 5000,
          position: "top"
        });
      } finally {
        this.$root.$emit("hide-loading");
      }
    }
  }
};
</script>
